/*
 * PanamaJack — Posiciona y anima el widget de chat activo (Tidio) y el botón de
 * accesibilidad (AccessEase) sobre la barra inferior móvil (.boton_filtro_coleccion /
 * .product-area__add-to-cart-xs), para que no se solapen.
 * Extraído de theme.js durante el rebase a Showcase 10.2.0 (iso-funcional).
 * Selector de chat genérico (iframe[title*="chat"]) → no depende de tawk (ya retirado).
 * Requiere jQuery (.is(':visible')); usa theme.jQuery con fallback a jQuery global.
 */
(function () {
  var $ = (window.theme && window.theme.jQuery) || window.jQuery;
  if (!$) return;

  var chatBounceStarted = false;
  var chatPositioned = false;
  var accessEasePositioned = false;

  function bounceChatWidget(widget) {
    widget.style.transition = "transform 0.15s ease-in-out";
    widget.style.transform = "translateY(-10px)";
    setTimeout(function () { widget.style.transform = "translateY(0)"; }, 150);
    setTimeout(function () {
      widget.style.transform = "translateY(-6px)";
      setTimeout(function () { widget.style.transform = "translateY(0)"; }, 150);
    }, 300);
  }

  function hasBottomBar() {
    return $(".boton_filtro_coleccion").is(":visible") || $(".product-area__add-to-cart-xs").is(":visible");
  }

  function checkElements() {
    var chatWidget = document.querySelector('iframe[title*="chat"]');
    var bottomBarVisible = hasBottomBar();

    if (chatWidget && !chatBounceStarted) {
      chatBounceStarted = true;
      setInterval(function () {
        var w = document.querySelector('iframe[title*="chat"]');
        if (w) bounceChatWidget(w);
      }, 6000);
    }

    if (!chatPositioned && chatWidget && bottomBarVisible) {
      chatWidget.style.setProperty("bottom", "80px", "important");
      chatPositioned = true;
    }

    if (!accessEasePositioned) {
      var botonAcesibilidad = document.querySelector('div[id*="accessease-icon"]');
      if (botonAcesibilidad && bottomBarVisible) {
        botonAcesibilidad.style.setProperty("bottom", "80px", "important");
        accessEasePositioned = true;
      }
    }

    if (chatBounceStarted && (chatPositioned || !bottomBarVisible) && (accessEasePositioned || !bottomBarVisible)) {
      widgetObserver.disconnect();
    }
  }

  var widgetObserver = new MutationObserver(checkElements);
  widgetObserver.observe(document.body, { childList: true, subtree: true });
  checkElements();
})();
